import DropdownSelect, {
  DropdownOption,
} from "@components/common/dropdown/DropdownSelect";
import { useAuth } from "@hooks";
import { useEffect } from "react";

function TeamFilterDropdown({
  isActive,
  userNoteCounts,
  currentTeam,
  selectedTeamMembers,
  setSelectedTeamMembers,
  refreshCurrentTeam,
}) {
  const { userUuid, currentUserData } = useAuth();

  useEffect(() => {
    if (isActive) {
      refreshCurrentTeam();
    }
  }, [isActive]);

  const handleMemberSelectChange = (event, value) => {
    if (event === null) {
      return;
    }
    if (value) {
      setSelectedTeamMembers([value]);
    } else {
      setSelectedTeamMembers([]);
    }
  };

  const handleAllTeamMembers = () => {
    setSelectedTeamMembers(
      currentTeam?.users?.map((user) => user.uuid) || [],
    );
  };

  const handleJustYou = () => {
    if (userUuid) {
      setSelectedTeamMembers([userUuid]);
    }
  };

  if (!currentTeam?.users) {
    return null;
  }
  return (
    <div className="relative flex flex-col gap-2">
      <DropdownSelect
        compact
        placeholder={"All"}
        value={
          selectedTeamMembers?.length > 1
            ? ""
            : selectedTeamMembers?.[0] ||
              currentUserData?.user?.uuid ||
              ""
        }
        onChange={handleMemberSelectChange}
        width="w-52"
        popupClassNameOverrides={`${isActive ? "block" : "hidden"}`}
        dataTestId="team-filter-select"
      >
        {currentTeam?.users?.map((user) => (
          <DropdownOption
            key={user.uuid}
            value={user.uuid}
            dataTestId={`team-filter-option-${user.uuid}`}
          >
            <span className="text-sm truncate flex justify-between items-center">
              <span>
                {user.firstName} {user.lastName}
                {user.uuid === userUuid && " (You)"}
              </span>
              {userNoteCounts && (
                <span className="text-gray-500 dark:text-gray-400">
                  {" "}
                  ({userNoteCounts[user.uuid] || 0})
                </span>
              )}
            </span>
          </DropdownOption>
        ))}
      </DropdownSelect>
      <div className="flex flex-row items-center gap-2">
        <button
          onClick={handleAllTeamMembers}
          className={`border border-indigo-500 rounded-full flex-1 py-1 text-sm text-center font-medium 
            ${
              selectedTeamMembers?.length ===
              currentTeam?.users?.length
                ? "bg-indigo-500 text-white border-indigo-500"
                : "text-indigo-500 hover:text-indigo-700"
            }`}
        >
          All Members
        </button>
        <button
          onClick={handleJustYou}
          className={`border border-indigo-500 rounded-full flex-1 py-1 text-sm text-center font-medium
            ${
              selectedTeamMembers?.length === 1 &&
              selectedTeamMembers[0] === userUuid
                ? "bg-indigo-500 text-white border-indigo-500"
                : "text-indigo-500 hover:text-indigo-700"
            }`}
        >
          Just You
        </button>
      </div>
    </div>
  );
}

export default TeamFilterDropdown;
